import { observable } from "mobx";
import { ModelBase } from "@shoothill/core";
import { RDDV2CategoryDTO } from "./RDDV2CategoryModel";
import { RDDV2StatusDTO, RDDV2FullStatusDTO } from "./RDDV2StatusModel";
import { RDDV2ItemModel, RDDV2ItemModelDTO } from "./RDDV2ItemModel";
import { RDDV2ItemResponseModel, RDDV2ItemResponseModelDTO } from "./RDDV2ItemResponseModel";

//Base class expects the model type and the DTO model type
//If you are not using a DTO just pass in undefined as the DTO
export class RDDV2Model extends ModelBase<RDDV2Model, RDDV2ModelDTO> {
    @observable
    public rddV2Items: RDDV2ItemModel[] = [];

    @observable
    public rddV2ItemResponses: RDDV2ItemResponseModel[] = [];

    //fromDto is required but you can leave it blank
    fromDto(model: RDDV2ModelDTO): void {
        //this just iterates through every key assigning it to the model
        //Should only use if there is a direct mapping between dto and domain model
        //otherwise just map them yourself
        for (let key in model) {
            if (model.hasOwnProperty(key)) {
                if (this[key] instanceof Date) {
                    this[key] = new Date(model[key]);
                } else if (key === "rddV2ListItems") {
                    // Do nothing.
                } else if (key === "rddV2Responses") {
                    // Do nothing.
                } else {
                    this[key] = model[key];
                }
            }
        }

        // Process the list
        let processedPos: RDDV2ItemModel[] = [];

        for (const item of model.rddV2ListItems) {
            const itemToAdd = new RDDV2ItemModel();
            itemToAdd.fromDto(item);
            processedPos.push(itemToAdd);
        }

        this.rddV2Items = processedPos;

        // Process the responses
        let processedResponsePos: RDDV2ItemResponseModel[] = [];

        for (const itemResponse of model.rddV2Responses) {
            const itemResponseToAdd = new RDDV2ItemResponseModel();
            itemResponseToAdd.fromDto(itemResponse);
            processedResponsePos.push(itemResponseToAdd);
        }

        this.rddV2ItemResponses = processedResponsePos;
    }

    //toDto is required but you can leave it blank
    toDto(model: RDDV2Model): void {}
}

export type RDDV2ModelDTO = {
    rddV2ListItems: RDDV2ItemModelDTO[];
    rddV2Categories: RDDV2CategoryDTO[];
    rddV2Statuses: RDDV2StatusDTO[];
    rddV2Responses: RDDV2ItemResponseModelDTO[];
    fullStatuses: RDDV2FullStatusDTO[];
};
